module.exports = __webpack_public_path__ + "static/media/add_new_product.e0acaa3d.png";